module.exports = __webpack_public_path__ + "img/gy_mb.2401b58d.jpg";